// Anonymous posts mask their author under this name on the wire. It can never
// collide with a real account: usernames are ^[a-zA-Z0-9_]+$, so the space
// makes it unregistrable and unsquattable.
//
// /user/Anonymous%20User is therefore not a profile. It renders the anonymous
// feed instead, so the author link on an anonymous post leads somewhere real.
export const ANONYMOUS_USERNAME = 'Anonymous User';

// Accepts the encoded form too: the name contains a space, so a route param
// reaches the page as "Anonymous%20User" while other callers hold it decoded.
export const isAnonymousUsername = (username: string): boolean => {
  if (username === ANONYMOUS_USERNAME) return true;
  try {
    return decodeURIComponent(username) === ANONYMOUS_USERNAME;
  } catch {
    return false;
  }
};
